import ResetPasswordContainer from "../../Component/AccountSettings/ResetPassword/ResetPassword"

const ResetPassword = () => {
  return (
    <div className='page-body'>
      <ResetPasswordContainer />
    </div>
  )
}

export default ResetPassword